
export default {
  quote: $vm => `/hotel/${$vm.$root.hotel}/quote/`,
  speedlog: $vm => `/hotel/${$vm.$root.hotel}/speedlog`,
  roomPlan: $vm => `/hotel/${$vm.$root.hotel}/room-plan`,
  roomPlanHousekeepingStatus: $vm => `/hotel/${$vm.$root.hotel}/room-plan/housekeeping`,
  roomPlanPaymentStatus: $vm => `/hotel/${$vm.$root.hotel}/room-plan/paymentStatus`,
  roomPlanReservation: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/room-plan/${$reservationId}?cacheBuster=${Math.floor(new Date() / 1000)}`,
  roomTypePlan: $vm => `/hotel/${$vm.$root.hotel}/room-type-plan`,
  weather: $vm => `/hotel/${$vm.$root.hotel}/weather`,
  enums: $vm => '/enums',
  login: $vm => '/login',
  resetPassword: $vm => '/login/reset',
  logout: $vm => '/logout',
  currentUser: $vm => '/user',
  uiVersion: $vm => '../../ui/version',
  inventoryLog: $vm => `/hotel/${$vm.$root.hotel}/inventoryLog`,
  holidays: $countryCodes => `https://api.hotelsoftware.io/rest/utility/holiday/${$countryCodes.join(',')}`,
  log: {
    info: '/log/info',
    warn: '/log/warn',
    error: '/log/error',
  },
  import: {
    import: $vm => `/hotel/${$vm.$root.hotel}/import`,
  },
  templateHelper: {
    list: $vm => `/hotel/${$vm.$root.hotel}/template`,
    filter: ($vm, $type) => `/hotel/${$vm.$root.hotel}/template?q=${$type}`,
    data: $vm => `/hotel/${$vm.$root.hotel}/template/data`,
    get: ($vm, $templateId) => `/hotel/${$vm.$root.hotel}/template/${$templateId}`,
    render: ($vm, $templateId) => `/hotel/${$vm.$root.hotel}/template/${$templateId}/render`,
    getEmail: $vm => `/hotel/${$vm.$root.hotel}/template/email`,
  },
  template: {
    list: $vm => `/hotel/${$vm.$root.hotel}/templateCRUD`,
    get: ($vm, $templateId) => `/hotel/${$vm.$root.hotel}/templateCRUD/${$templateId}`,
    uploadFile: ($vm, $templateId, $fileKey) => `/hotel/${$vm.$root.hotel}/templateCRUD/${$templateId}/${$fileKey}`,
  },
  user: {
    list: $vm => `/hotel/${$vm.$root.hotel}/user`,
    get: ($vm, $userId) => `/hotel/${$vm.$root.hotel}/user/${$userId}`,
    requestPasswordReset: ($vm, $userId) => `/hotel/${$vm.$root.hotel}/user/${$userId}/requestPasswordReset`,
  },
  receipt: {
    list: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/receipt`,
  },
  folio: {
    list: ($vm, $parentId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}`,
    createFolio: ($vm, $parentId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}`,
    get: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}`,
    email: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/email`,
    transferTargets: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/transferTargets`,
    addPayment: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/payment`,
    addPaymentCreateInvoice: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/payment?invoice=true`,
    addPrePayment: ($vm, $parentId, $folioId, $transactionCodeId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/payment/${$transactionCodeId}`,
    deletePayment: ($vm, $parentId, $folioId, $paymentProcessId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/payment/${$paymentProcessId}`,
    createInvoice: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/createInvoice`,
    cancelInvoice: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/cancelInvoice`,
    createPrePaymentInvoice: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/createPrePaymentInvoice`,
    createPDF: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/createPDF`,
    recreatePDF: ($vm, $parentId, $folioId, $invoiceNumber) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/createPDF/${$invoiceNumber}`,
    transactions: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/transactions`,
    payments: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/payments`,
    correspondence: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/files`,
    paymentStatus: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/paymentStatus`,
    addTransaction: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/transaction`,
    updateTransaction: ($vm, $parentId, $folioId, $transactionId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/transaction/${$transactionId}`,
    transferTransaction: ($vm, $parentId, $folioId, $transactionId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/transaction/${$transactionId}/transfer`,
    transferTransactionIn: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/transferIn`,
    transferTransactionInMultiple: ($vm, $parentId, $folioId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/transferInMultiple`,
    splitTransaction: ($vm, $parentId, $folioId, $transactionId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/transaction/${$transactionId}/split`,
    deleteTransaction: ($vm, $parentId, $folioId, $transactionId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/transaction/${$transactionId}`,
    restoreTransaction: ($vm, $parentId, $folioId, $transactionId) => `/hotel/${$vm.$root.hotel}/folio/${$parentId}/${$folioId}/cancelledTransaction/${$transactionId}`,
  },
  tenant: {
    create: () => '/tenant',
  },
  hotel: {
    list: () => '/hotel',
    get: $vm => `/hotel/${$vm.$root.hotel}`,
    notifications: $vm => `/hotel/${$vm.$root.hotel}/notification`,
    readNotifications: $vm => `/hotel/${$vm.$root.hotel}/notification/read`,
    unreadNotifications: $vm => `/hotel/${$vm.$root.hotel}/notification/unread`,
    notification: ($vm, $notificationId) => `/hotel/${$vm.$root.hotel}/notification/${$notificationId}`,
    readAllNotifications: $vm => `/hotel/${$vm.$root.hotel}/notification/readAll`,
  },
  support: {
    chatbot: {
      streaming: $vm => `/hotel/${$vm.$root.hotel}/support/chatbot/streaming`,
      waiting: $vm => `/hotel/${$vm.$root.hotel}/support/chatbot/waiting`,
    },
  },
  cashBook: {
    list: $vm => `/hotel/${$vm.$root.hotel}/cashBook`,
    get: ($vm, $date) => `/hotel/${$vm.$root.hotel}/cashBook/${$date}`,
    cancelEntry: ($vm, $date, $entryId) => `/hotel/${$vm.$root.hotel}/cashBook/${$date}/${$entryId}`,
    getCashCheck: ($vm, $date) => `/hotel/${$vm.$root.hotel}/cashBook/${$date}/cashCheck`,
  },
  frontDesk: {
    statistic: $vm => `/hotel/${$vm.$root.hotel}/frontDesk/statistic`,
    birthday: $vm => `/hotel/${$vm.$root.hotel}/frontDesk/birthday`,
    notes: $vm => `/hotel/${$vm.$root.hotel}/notes`,
    notesArchive: $vm => `/hotel/${$vm.$root.hotel}/notes/archive`,
    note: ($vm, $noteId) => `/hotel/${$vm.$root.hotel}/notes/${$noteId}`,
  },
  guest: {
    add: $vm => `/hotel/${$vm.$root.hotel}/guest`,
    zipCode: ($vm, $zipCode, $country = null) => `/hotel/${$vm.$root.hotel}/guest/zipCode?zipCode=${$zipCode}&country=${$country || ''}`,
    get: ($vm, $guestProfileId) => `/hotel/${$vm.$root.hotel}/guest/${$guestProfileId}`,
    create: ($vm, $profileType) => `/hotel/${$vm.$root.hotel}/guest?profileType=${$profileType}`,
    email: ($vm, $guestProfileId) => `/hotel/${$vm.$root.hotel}/guest/${$guestProfileId}/email`,
    getFull: ($vm, $guestProfileId) => `/hotel/${$vm.$root.hotel}/guest/${$guestProfileId}?fields=addresses,phoneNumbers,emailAddresses,history`,
    getHistory: ($vm, $guestProfileId) => `/hotel/${$vm.$root.hotel}/guest/${$guestProfileId}?fields=history`,
    find: $vm => `/hotel/${$vm.$root.hotel}/guest/`,
    paymentStatus: ($vm, $guestProfileId) => `/hotel/${$vm.$root.hotel}/guest/${$guestProfileId}/paymentStatus`,
    correspondence: ($vm, $guestProfileId) => `/hotel/${$vm.$root.hotel}/guest/${$guestProfileId}/correspondence`,
    reservations: ($vm, $guestProfileId) => `/hotel/${$vm.$root.hotel}/guest/${$guestProfileId}/reservations`,
    fellowTravellers: ($vm, $guestProfileId) => `/hotel/${$vm.$root.hotel}/guest/${$guestProfileId}/fellowTravellers`,
    offers: ($vm, $guestProfileId) => `/hotel/${$vm.$root.hotel}/guest/${$guestProfileId}/offers`,
  },
  reservation: {
    get: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/reservation/${$reservationId}`,
    updateMeldeblattDates: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/reservation/${$reservationId}/updateMeldeblattDates`,
    email: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/reservation/${$reservationId}/email`,
    document: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/reservation/${$reservationId}/document`,
    find: $vm => `/hotel/${$vm.$root.hotel}/reservation/`,
    sourceName: $vm => `/hotel/${$vm.$root.hotel}/reservation/sourceName`,
    rates: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/reservation/${$reservationId}/rates`,
    action: ($vm, $reservationId, $action) => `/hotel/${$vm.$root.hotel}/reservation/${$reservationId}/do${$action}`,
    paymentStatus: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/reservation/${$reservationId}/paymentStatus`,
    correspondence: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/reservation/${$reservationId}/correspondence`,
    key: {
      get: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/reservation/${$reservationId}/key`,
      card: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/reservation/${$reservationId}/key/card`,
      delete: ($vm, $reservationId, $keyId) => `/hotel/${$vm.$root.hotel}/reservation/${$reservationId}/key/${$keyId}`,
    },
  },
  selfCheckIn: {
    list: $vm => `/hotel/${$vm.$root.hotel}/selfCheckIn/arrivals`,
    update: $vm => `/hotel/${$vm.$root.hotel}/selfCheckIn/arrivals`,
    recalculateEligibility: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/selfCheckIn/${$reservationId}/recalculateEligibility`,
    reviewStatus: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/selfCheckIn/${$reservationId}/reviewStatus`,
    roomAmountOverride: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/selfCheckIn/${$reservationId}/roomAmountOverride`,
    updateEligibility: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/selfCheckIn/${$reservationId}/updateEligibility`,
  },
  paymentRequest: {
    get: ($vm, $paymentRequestId) => `/hotel/${$vm.$root.hotel}/paymentRequest/${$paymentRequestId}`,
    create: ($vm, $type) => `/hotel/${$vm.$root.hotel}/paymentRequest/${$type}`,
    delete: ($vm, $paymentRequestId) => `/hotel/${$vm.$root.hotel}/paymentRequest/${$paymentRequestId}`,
    paid: ($vm, $paymentRequestId) => `/hotel/${$vm.$root.hotel}/paymentRequest/${$paymentRequestId}/paid`,
    findByReservationId: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/paymentRequest/?reservationId=${$reservationId}`,
    findByConfirmationNumber: ($vm, $confirmationNumber) => `/hotel/${$vm.$root.hotel}/paymentRequest/?confirmationNumber=${$confirmationNumber}`,
  },
  meldeblatt: {
    get: ($vm, $meldeblattId) => `/hotel/${$vm.$root.hotel}/meldeblatt/${$meldeblattId}`,
    html: ($vm, $meldeblattId) => `/hotel/${$vm.$root.hotel}/meldeblatt/${$meldeblattId}/html`,
    delete: ($vm, $meldeblattId) => `/hotel/${$vm.$root.hotel}/meldeblatt/${$meldeblattId}`,
    findByReservationId: ($vm, $reservationId) => `/hotel/${$vm.$root.hotel}/meldeblatt/?reservationId=${$reservationId}`,
    findByConfirmationNumber: ($vm, $confirmationNumber) => `/hotel/${$vm.$root.hotel}/meldeblatt/?confirmationNumber=${$confirmationNumber}`,
    clone: ($vm, $meldeblattId) => `/hotel/${$vm.$root.hotel}/meldeblatt/${$meldeblattId}/clone`,
    updateFromReservations: ($vm, $meldeblattId) => `/hotel/${$vm.$root.hotel}/meldeblatt/${$meldeblattId}/doUpdate`,
    cancel: ($vm, $meldeblattId) => `/hotel/${$vm.$root.hotel}/meldeblatt/${$meldeblattId}/doCancel`,
    depart: ($vm, $meldeblattId) => `/hotel/${$vm.$root.hotel}/meldeblatt/${$meldeblattId}/doDepart`,
    preRegistration: ($vm, $meldeblattId) => `/hotel/${$vm.$root.hotel}/meldeblatt/${$meldeblattId}/doPreRegistration`,
    registration: ($vm, $meldeblattId) => `/hotel/${$vm.$root.hotel}/meldeblatt/${$meldeblattId}/doRegistration`,
    print: ($vm, $meldeblattId) => `/hotel/${$vm.$root.hotel}/meldeblatt/${$meldeblattId}/doPrint`,
    retrieve: ($vm, $meldeblattId) => `/hotel/${$vm.$root.hotel}/meldeblatt/${$meldeblattId}/doRetrieve`,
    sendToKiosk: ($vm, $meldeblattId) => `/hotel/${$vm.$root.hotel}/meldeblatt/${$meldeblattId}/sendToKiosk`,
    deleteSignature: ($vm, $meldeblattId) => `/hotel/${$vm.$root.hotel}/meldeblatt/${$meldeblattId}/signature`,
  },
  inventory: {
    find: ($vm, $startDate, $numberOfNights = '') => `/hotel/${$vm.$root.hotel}/inventory?start=${$startDate}&limit=${$numberOfNights}`,
    update: $vm => `/hotel/${$vm.$root.hotel}/inventory`,
    get: ($vm, $inventoryId) => `/hotel/${$vm.$root.hotel}/inventory/${$inventoryId}`,
  },
  reservationGroup: {
    get: ($vm, $confirmationNumberOrReservationGroupId) => `/hotel/${$vm.$root.hotel}/reservationGroup/${$confirmationNumberOrReservationGroupId}`,
    find: ($vm, $startDate, $numberOfNights) => `/hotel/${$vm.$root.hotel}/reservationGroup?start=${$startDate}&limit=${$numberOfNights}`,
    email: ($vm, $confirmationNumberOrReservationGroupId) => `/hotel/${$vm.$root.hotel}/reservationGroup/${$confirmationNumberOrReservationGroupId}/email`,
    updateReservations: ($vm, $confirmationNumberOrReservationGroupId) => `/hotel/${$vm.$root.hotel}/reservationGroup/${$confirmationNumberOrReservationGroupId}/reservation`,
  },
  newReservation: {
    request: $vm => `/hotel/${$vm.$root.hotel}/newReservation/request`,
    notification: $vm => `/hotel/${$vm.$root.hotel}/newReservation/notification`,
    rates: $vm => `/hotel/${$vm.$root.hotel}/newReservation/recalculate`,
  },
  inquiry: {
    get: ($vm, $inquiryId) => `/hotel/${$vm.$root.hotel}/inquiry/${$inquiryId}`,
    email: ($vm, $inquiryId) => `/hotel/${$vm.$root.hotel}/inquiry/${$inquiryId}/email`,
    createOffer: ($vm, $inquiryId) => `/hotel/${$vm.$root.hotel}/inquiry/${$inquiryId}/createOffer`,
    correspondence: ($vm, $inquiryId) => `/hotel/${$vm.$root.hotel}/inquiry/${$inquiryId}/correspondence`,
    find: $vm => `/hotel/${$vm.$root.hotel}/inquiry/`,
  },
  offer: {
    create: $vm => `/hotel/${$vm.$root.hotel}/offer`,
    get: ($vm, $offerId) => `/hotel/${$vm.$root.hotel}/offer/${$offerId}`,
    email: ($vm, $offerId) => `/hotel/${$vm.$root.hotel}/offer/${$offerId}/email`,
    rates: ($vm, $offerId) => `/hotel/${$vm.$root.hotel}/offer/${$offerId}/rates`,
    correspondence: ($vm, $offerId) => `/hotel/${$vm.$root.hotel}/offer/${$offerId}/correspondence`,
    roomOfferRates: ($vm, $offerId, $roomOfferId) => `/hotel/${$vm.$root.hotel}/offer/${$offerId}/${$roomOfferId}/rates`,
    createPDF: ($vm, $offerId) => `/hotel/${$vm.$root.hotel}/offer/${$offerId}/createPDF`,
    createReservation: ($vm, $offerId, $roomOfferId, $overbook = false) => `/hotel/${$vm.$root.hotel}/offer/${$offerId}/${$roomOfferId}/createReservation?overbook=${$overbook}`,
    find: $vm => `/hotel/${$vm.$root.hotel}/offer/`,
  },
  availability: {
    unavailableRooms: $vm => `/hotel/${$vm.$root.hotel}/availability/unavailableRooms`,
  },
  image: {
    delete: ($vm, $parentId, $imageId) => `/hotel/${$vm.$root.hotel}/image/${$parentId}/${$imageId}`,
  },
  aiTextGenerator: {
    roomTypeDescription: ($vm, $roomTypeId) => `/hotel/${$vm.$root.hotel}/aiTextGenerator/roomType/${$roomTypeId}/description`,
    ratePlanDescription: ($vm, $ratePlanId) => `/hotel/${$vm.$root.hotel}/aiTextGenerator/ratePlan/${$ratePlanId}/description`,
    propertyDescription: $vm => `/hotel/${$vm.$root.hotel}/aiTextGenerator/property/description`,
    hotelHighlights: $vm => `/hotel/${$vm.$root.hotel}/aiTextGenerator/highlights`,
    hotelIncludedServices: $vm => `/hotel/${$vm.$root.hotel}/aiTextGenerator/includedServices`,
    hotelOfferIntro: $vm => `/hotel/${$vm.$root.hotel}/aiTextGenerator/offerIntro`,
  },
  roomType: {
    list: $vm => `/hotel/${$vm.$root.hotel}/roomType`,
    sort: $vm => `/hotel/${$vm.$root.hotel}/roomType/sort`,
    get: ($vm, $roomTypeId) => `/hotel/${$vm.$root.hotel}/roomType/${$roomTypeId}`,
  },
  ratePlan: {
    list: $vm => `/hotel/${$vm.$root.hotel}/ratePlan`,
    sort: $vm => `/hotel/${$vm.$root.hotel}/ratePlan/sort`,
    get: ($vm, $ratePlanId) => `/hotel/${$vm.$root.hotel}/ratePlan/${$ratePlanId}`,
  },
  inHouseService: {
    list: $vm => `/hotel/${$vm.$root.hotel}/inHouseService`,
    sort: $vm => `/hotel/${$vm.$root.hotel}/inHouseService/sort`,
    get: ($vm, $inHouseServiceId) => `/hotel/${$vm.$root.hotel}/inHouseService/${$inHouseServiceId}`,
  },
  ageCategory: {
    list: $vm => `/hotel/${$vm.$root.hotel}/ageCategory`,
    sort: $vm => `/hotel/${$vm.$root.hotel}/ageCategory/sort`,
    get: ($vm, $ageCategoryId) => `/hotel/${$vm.$root.hotel}/ageCategory/${$ageCategoryId}`,
  },
  guestCategory: {
    list: $vm => `/hotel/${$vm.$root.hotel}/guestCategory`,
    get: ($vm, $guestCategoryId) => `/hotel/${$vm.$root.hotel}/guestCategory/${$guestCategoryId}`,
  },
  messagingSequence: {
    list: ($vm, $messagingSequenceType) => `/hotel/${$vm.$root.hotel}/messagingSequence/${$messagingSequenceType}`,
    get: ($vm, $messagingSequenceType, $messagingSequenceId) => `/hotel/${$vm.$root.hotel}/messagingSequence/${$messagingSequenceType}/${$messagingSequenceId}`,
  },
  room: {
    list: $vm => `/hotel/${$vm.$root.hotel}/room`,
    sort: $vm => `/hotel/${$vm.$root.hotel}/room/sort`,
    get: ($vm, $roomId) => `/hotel/${$vm.$root.hotel}/room/${$roomId}`,
  },
  mealPlan: {
    list: $vm => `/hotel/${$vm.$root.hotel}/mealPlan`,
    get: ($vm, $roomId) => `/hotel/${$vm.$root.hotel}/mealPlan/${$roomId}`,
  },
  policy: {
    list: $vm => `/hotel/${$vm.$root.hotel}/policy`,
    get: ($vm, $roomId) => `/hotel/${$vm.$root.hotel}/policy/${$roomId}`,
  },
  tax: {
    list: $vm => `/hotel/${$vm.$root.hotel}/tax`,
    get: ($vm, $roomId) => `/hotel/${$vm.$root.hotel}/tax/${$roomId}`,
  },
  taxSet: {
    list: $vm => `/hotel/${$vm.$root.hotel}/taxSet`,
    get: ($vm, $roomId) => `/hotel/${$vm.$root.hotel}/taxSet/${$roomId}`,
  },
  discountCode: {
    list: $vm => `/hotel/${$vm.$root.hotel}/discountCode`,
    get: ($vm, $roomId) => `/hotel/${$vm.$root.hotel}/discountCode/${$roomId}`,
  },
  season: {
    list: $vm => `/hotel/${$vm.$root.hotel}/season`,
    sort: $vm => `/hotel/${$vm.$root.hotel}/season/sort`,
    get: ($vm, $seasonId) => `/hotel/${$vm.$root.hotel}/season/${$seasonId}`,
    dates: ($vm, $seasonId) => `/hotel/${$vm.$root.hotel}/season/${$seasonId}/dates`,
    cleanup: ($vm) => `/hotel/${$vm.$root.hotel}/season/cleanup`,
  },
  seasonDate: {
    list: ($vm, $startDate, $endDate) => `/hotel/${$vm.$root.hotel}/seasonDate?start=${$startDate}&end=${$endDate}`,
    color: ($vm, $startDate, $endDate) => `/hotel/${$vm.$root.hotel}/seasonDate/color?start=${$startDate}&end=${$endDate}`,
    get: ($vm, $date) => `/hotel/${$vm.$root.hotel}/seasonDate/${$date}`,
  },
  hotelDetails: {
    base: $vm => `/hotel/${$vm.$root.hotel}/detail/base`,
    invoice: $vm => `/hotel/${$vm.$root.hotel}/detail/invoice`,
    settings: $vm => `/hotel/${$vm.$root.hotel}/detail/settings`,
    verifyEmailSender: $vm => `/hotel/${$vm.$root.hotel}/detail/verifyEmailSender`,
    verifyEmailDomain: $vm => `/hotel/${$vm.$root.hotel}/detail/verifyEmailDomain`,
    verifyEmailFromDomain: $vm => `/hotel/${$vm.$root.hotel}/detail/verifyEmailFromDomain`,
    removeEmailFromDomain: $vm => `/hotel/${$vm.$root.hotel}/detail/removeEmailFromDomain`,
    deactivate: $vm => `/hotel/${$vm.$root.hotel}/detail/deactivate`,
    reactivate: $vm => `/hotel/${$vm.$root.hotel}/detail/reactivate`,
    uploadFile: ($vm, $fileKey) => `/hotel/${$vm.$root.hotel}/detail/${$fileKey}`,
    removePartnerAdmin: ($vm, $tenantId) => `/hotel/${$vm.$root.hotel}/detail/partnerAdmin/${$tenantId}`,
    addPartnerAdmin: $vm => `/hotel/${$vm.$root.hotel}/detail/partnerAdmin`,
    createPastHotelDates: $vm => `/hotel/${$vm.$root.hotel}/detail/createPastHotelDates`,
  },
  dailyRate: {
    get: ($vm, $ratePlanId, $startDate, $days) => `/hotel/${$vm.$root.hotel}/dayRate/${$ratePlanId}?startDate=${$startDate}&days=${$days}`,
    overview: ($vm, $startDate, $days, $occupancy) => `/hotel/${$vm.$root.hotel}/dayRate/overview?startDate=${$startDate}&days=${$days}&occupancy=${$occupancy}`,
    update: ($vm, $ratePlanId) => `/hotel/${$vm.$root.hotel}/dayRate/${$ratePlanId}`,
  },
  seasonRate: {
    get: ($vm, $ratePlanId) => `/hotel/${$vm.$root.hotel}/seasonRate/${$ratePlanId}`,
    updateRoomTypeRatePlanSeasonDetail: ($vm, $ratePlanId) => `/hotel/${$vm.$root.hotel}/seasonRate/${$ratePlanId}/roomTypeRatePlanSeasonDetail`,
    updateRatePlanSeasonDetail: ($vm, $ratePlanId) => `/hotel/${$vm.$root.hotel}/seasonRate/${$ratePlanId}/ratePlanSeasonDetail`,
    calculate: ($vm, $ratePlanId, $byOccupancy = false) => `/hotel/${$vm.$root.hotel}/seasonRate/${$ratePlanId}/rate?byOccupancy=${$byOccupancy}`,
    cleanup: ($vm) => `/hotel/${$vm.$root.hotel}/seasonRate/cleanup`,
  },
  interfaces: {
    logs: {
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/logs`,
      content: $vm => `/hotel/${$vm.$root.hotel}/interface/logs/content`,
    },
    kiosk: {
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/kiosk`,
      get: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/kiosk/${$interfaceId}`,
      pair: ($vm, $interfaceId, $pairingKey) => `/hotel/${$vm.$root.hotel}/interface/kiosk/${$interfaceId}/pair?pairingKey=${$pairingKey}`,
      clearTokens: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/kiosk/${$interfaceId}/clearTokens`,
    },
    locking: {
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/locking`,
      get: $vm => `/hotel/${$vm.$root.hotel}/interface/locking`,
      loxone: {
        controls: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/locking/${$interfaceId}/loxone/controls`,
      },
      charPmsLink: {
        controls: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/locking/${$interfaceId}/charPmsLink/config`,
      },
      seam: {
        locks: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/locking/${$interfaceId}/seam/locks`,
        connect: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/locking/${$interfaceId}/seam/connect`,
        session: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/locking/${$interfaceId}/seam/session`,
      },
    },
    hotelSpider: {
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/hotelSpider`,
      get: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/hotelSpider/${$interfaceId}`,
      refreshData: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/hotelSpider/${$interfaceId}/refreshData`,
      updateRates: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/hotelSpider/${$interfaceId}/updateRates`,
      updateAvailability: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/hotelSpider/${$interfaceId}/updateAvailability`,
      retrieveReservations: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/hotelSpider/${$interfaceId}/retrieveReservations`,
      retrieveReservation: ($vm, $interfaceId, $reservationId) => `/hotel/${$vm.$root.hotel}/interface/hotelSpider/${$interfaceId}/retrieveReservation/${$reservationId}`,
    },
    channelManagerSu: {
      create: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS`,
      delete: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS`,
      get: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS`,
      paymentGateway: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/paymentGateway`,
      reservations: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/reservations`,
      roomTypes: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/roomTypes`,
      ratePlans: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/ratePlans`,
      chain: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/chain`,
      updateRatesAndAvailabilities: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/updateRatesAndAvailabilities`,
      logs: ($vm, $date) => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/logs/update?date=${$date}`,
      logMapping: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/logs/mappings`,
      logFailed: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/logs/failed`,
      logRateInventory: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/logs/rateInventory`,
      retryFailed: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/logs/retryFailed`,
      mappingIframe: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/iframe/mapping`,
      bookingIframe: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/iframe/booking`,
      mappingWidget: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/v2/widget/mapping`,
      images: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectS/v2/images`,
    },
    channelManagerCx: {
      create: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}`,
      delete: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}`,
      get: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}`,
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX`,
      reservations: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/reservations`,
      futureReservations: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/futureReservations`,
      reservation: ($vm, $configId, $bookingId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/reservation/${$bookingId}`,
      roomTypes: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/roomTypes`,
      cleanup: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/cleanup`,
      ratePlans: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/ratePlans`,
      taxesFees: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/taxSets`,
      chain: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/chain`,
      subscribe: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/subscribe`,
      propertyFacilities: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/property/facilities`,
      updateCancellationPolicies: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/updateCancellationPolicies`,
      updateRatesAndAvailabilities: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/updateRatesAndAvailabilities`,
      updateGoogleChannelConnection: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/updateGoogleChannelConnection`,
      mappingIframe: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/iframe/mapping`,
      bookingsIframe: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/iframe/bookings`,
      roomsIframe: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/iframe/rooms`,
      inventoryIframe: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/iframe/inventory`,
      dashboardIframe: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/iframe/dashboard`,
      propertyIframe: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/${$configId}/iframe/property`,
      // bookingIframe: $vm => `/hotel/${$vm.$root.hotel}/interface/cmConnectCX/iframe/booking`,
    },
    charPmsLink: {
      create: $vm => `/hotel/${$vm.$root.hotel}/interface/charPmsLink`,
      delete: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/charPmsLink/${$configId}`,
      get: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/charPmsLink/${$configId}`,
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/charPmsLink`,
    },
    smartpricing: {
      // create: $vm => `/hotel/${$vm.$root.hotel}/interface/smartpricing`,
      delete: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/smartpricing/${$configId}`,
      get: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/smartpricing/${$configId}`,
      sendReservation: ($vm, $configId, $reservationId) => `/hotel/${$vm.$root.hotel}/interface/smartpricing/${$configId}/reservation/${$reservationId}`,
      sendHistoricReservations: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/smartpricing/${$configId}/sendHistoricReservations`,
      retrievePrices: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/smartpricing/${$configId}/retrievePrices`,
      resetPrices: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/smartpricing/${$configId}/resetPrices`,
      resetReservations: ($vm, $configId) => `/hotel/${$vm.$root.hotel}/interface/smartpricing/${$configId}/resetReservations`,
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/smartpricing`,
    },
    interalpSalesbox: {
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/interalpSalesbox`,
      create: $vm => `/hotel/${$vm.$root.hotel}/interface/interalpSalesbox`,
      get: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/interalpSalesbox/${$interfaceId}`,
      updateAvailability: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/interalpSalesbox/${$interfaceId}/updateAvailability`,
      retrieveReservations: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/interalpSalesbox/${$interfaceId}/retrieveReservations`,
    },
    meldeclient: {
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/meldeblatt`,
      create: $vm => `/hotel/${$vm.$root.hotel}/interface/meldeblatt`,
      get: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/meldeblatt/${$interfaceId}`,
      updateConfig: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/meldeblatt/${$interfaceId}/updateConfig`,
      updateMeldeblattNumbers: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/meldeblatt/${$interfaceId}/updateMeldeblattNumbers`,
      retrievePreCheckIns: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/meldeblatt/${$interfaceId}/retrievePreCheckIns`,
    },
    aTrustRegMobile: {
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/aTrustRegMobile`,
      get: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/aTrustRegMobile/${$interfaceId}`,
      refreshData: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/aTrustRegMobile/${$interfaceId}/refreshData`,
    },
    fiskaltrustDE: {
      config: $vm => `/hotel/${$vm.$root.hotel}/interface/fiskaltrustDE/config`,
      restart: $vm => `/hotel/${$vm.$root.hotel}/interface/fiskaltrustDE/restart`,
      rollout: $vm => `/hotel/${$vm.$root.hotel}/interface/fiskaltrustDE/rollout`,
      rolloutExistingTSE: $vm => `/hotel/${$vm.$root.hotel}/interface/fiskaltrustDE/rolloutExistingTSE`,
      status: $vm => `/hotel/${$vm.$root.hotel}/interface/fiskaltrustDE/journal/status`,
      tseTar: $vm => `/hotel/${$vm.$root.hotel}/interface/fiskaltrustDE/journal/tseTar`,
      middlewareTar: $vm => `/hotel/${$vm.$root.hotel}/interface/fiskaltrustDE/journal/middlewareTar`,
      DSFinVK: $vm => `/hotel/${$vm.$root.hotel}/interface/fiskaltrustDE/journal/DSFinVK`,
    },
    exchangeRate: {
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/exchangeRate`,
      get: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/exchangeRate/${$interfaceId}`,
      getRates: $vm => `/hotel/${$vm.$root.hotel}/interface/exchangeRate/rates`,
      convert: ($vm, $amount, $from, $to) => `/hotel/${$vm.$root.hotel}/interface/exchangeRate/convert?amount=${$amount}&from=${$from}&to=${$to}`,
    },
    mollie: {
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/mollie`,
      get: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/mollie/${$interfaceId}`,
      connect: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/mollie/${$interfaceId}/connect`,
      updateProfiles: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/mollie/${$interfaceId}/updateProfiles`,
      createPayment: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/mollie/${$interfaceId}/createPayment`,
    },
    stripe: {
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/stripe`,
      get: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/stripe/${$interfaceId}`,
      connect: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/stripe/${$interfaceId}/connect`,
    },
    fanz: {
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/fanz`,
      get: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/fanz/${$interfaceId}`,
    },
    genericPos: {
      get: $vm => `/hotel/${$vm.$root.hotel}/interface/genericPos`,
    },
    iCal: {
      list: $vm => `/hotel/${$vm.$root.hotel}/interface/iCal`,
      get: ($vm, $interfaceId) => `/hotel/${$vm.$root.hotel}/interface/iCal/${$interfaceId}`,
    },
    onlineBooking: {
      get: $vm => `/hotel/${$vm.$root.hotel}/interface/onlineBooking`,
      createPaymentRegisteredTemplate: $vm => `/hotel/${$vm.$root.hotel}/interface/onlineBooking/createPaymentRegisteredTemplate`,
    },
    paymentRequest: {
      get: $vm => `/hotel/${$vm.$root.hotel}/interface/paymentRequest`,
    },
  },
  registrierkasse: {
    at: {
      get: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/at`,
      listReceipts: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/at/receipt`,
      createAESKey: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/at/createAESKey`,
      createStartReceipt: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/at/createStartReceipt`,
      createNullReceipt: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/at/createNullReceipt`,
      createSummaryReceipt: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/at/createSummaryReceipt`,
    },
    de: {
      listReceipts: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/de/receipt`,
      listReceiptsByYear: ($vm, $year) => `/hotel/${$vm.$root.hotel}/registrierkasse/de/receipt/${$year}`,
      createStartReceipt: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/de/createStartReceipt`,
      createNullReceipt: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/de/createNullReceipt`,
      createDayReceipt: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/de/createDayReceipt`,
      initiateSCUSwitch: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/de/initiateSCUSwitch`,
      finishSCUSwitch: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/de/finishSCUSwitch`,
      outOfOperation: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/de/outOfOperation`,
      autoClosing: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/de/autoClosing`,
      activate: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/de/activate`,
      lockOpenFolios: $vm => `/hotel/${$vm.$root.hotel}/registrierkasse/de/lockOpenFolios`,
    },
  },
  report: {
    get: ($vm, $reportId) => `/hotel/${$vm.$root.hotel}/report/${$reportId}`,
    legacy: ($vm, $reportName) => `/hotel/${$vm.$root.hotel}/report/custom/${$reportName}`,
    data: ($vm, $reportId) => `/hotel/${$vm.$root.hotel}/report/${$reportId}/data`,
  },
  cockpit: {
    pickup: ($vm, $granularity) => `/hotel/${$vm.$root.hotel}/report/pickup/chart?granularity=${$granularity}`,
    shortTermPickup: $vm => `/hotel/${$vm.$root.hotel}/report/pickup/shortTerm`,
    shortTermPreviousYearPickup: $vm => `/hotel/${$vm.$root.hotel}/report/pickup/shortTermPreviousYear`,
  },
  hotelmeisterInvoice: {
    list: $vm => `/hotel/${$vm.$root.hotel}/hotelmeisterinvoice`,
    download: ($vm, $invoiceId) => `hotel/${$vm.$root.hotel}/hotelmeisterinvoice/${$invoiceId}`,
  },
};



// WEBPACK FOOTER //
// ./src/lib/ServiceUrls.js